import { Members } from "../../../listsSettings/members";

export const allItems: string = `/${Members.InternalName}/_lists/${Members.Lists.Members.InternalName}/_pages/all_items`;
export const dispForm: string = `/${Members.InternalName}/_lists/${Members.Lists.Members.InternalName}/_pages/disp`;
